(function($) {

    var isIE = '-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style;

    if ($('.page-template-template-about').length) {

        var navHeight = $('.about-page .page-nav-wrapper').outerHeight() + "px";
        $('.about-page [data-scroll-position="1"]').css('margin-top', '-'+navHeight).addClass('altered');

        $('.about-page [data-scroll-position="1"]').css('opacity', '1');

        $('.about-page .page-nav li').on('click', function() {
            var target = $(this).data('scroll');
            var offset = $('.about-page [data-scroll-position="'+target+'"]').offset().top;
            $('html, body').animate({ scrollTop: offset }, 300);
        })

        window.addEventListener('DOMContentLoaded', function() {
            if (!isIE) {
                var observer = new IntersectionObserver(function (entries) {
                    entries.forEach(entry => {
                        let target = $(entry.target).data('scroll-position');

                        if (entry.isIntersecting) {
                            $('.about-page .page-nav li[data-scroll="'+target+'"]').addClass('active');
                        } else {
                            $('.about-page .page-nav li[data-scroll="'+target+'"]').removeClass('active');
                        }
                    });
                }, {
                    rootMargin: '0px',
                    threshold: 0.5
                });

                $('.about-page [data-scroll-position]').each(function(index, el) {
                    observer.observe(el);
                });
            }
        });
    }

})( jQuery );